import axios, { AxiosResponse } from 'axios'

import { env } from '@js/utils/env'
import gql from '@js/api/utils/gql'
import getStoreName from '@js/api/utils/getStoreName'
import getBearerToken from '@js/api/utils/getBearerToken'
import { CustomerLicense } from '@js/api/types/customer/CustomerLicense'

interface GetCustomerLicensesResponse {
  data: {
    getCustomerLicenses: CustomerLicense[]
  }
  errors?: [{ message: string }]
}

export const customerLicensesQuery = gql`
  query GetCustomerLicenses {
    getCustomerLicenses {
      customer_id
      license_id
      license_number
      license_state
      license_type
      license_profession_id
    }
  }
`

/**
 * @throws {string}
 *
 * Will throw one error message; Magento only returns one at a time, rather than an array of all errors.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getCustomerLicenses = async (_customerId: number): Promise<CustomerLicense[]> => {
  const bearerToken = getBearerToken()

  const { data }: AxiosResponse<GetCustomerLicensesResponse> = await axios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
      Store: getStoreName(),
    },
    data: {
      query: customerLicensesQuery,
    },
  })

  if (data.errors) {
    throw data.errors[0].message
  }

  return data.data.getCustomerLicenses
}
